// Converts an arbitrary string into a kebab-case slug (lowercase-with-dashes)
// safe to use as a filename. Falls back to `fallback` when the input is
// empty/missing or produces an empty slug (e.g. it was made up entirely of
// unsupported characters).
export const slugify = (value, fallback = "report-summary") => {
  const slug = String(value ?? "")
    .toLowerCase()
    .trim()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "") // strip accents (e.g. "é" -> "e")
    .replace(/[^a-z0-9]+/g, "-") // any non-alphanumeric run -> single dash
    .replace(/^-+|-+$/g, ""); // trim leading/trailing dashes

  return slug || fallback;
};
